import {action, observable} from 'mobx';
import {login, getUserInfo} from '@/services/SignIn';
import stores from '@/stores';
import log from '@/utils/log';

export interface accountTypes {
    mobile: string;
    password: string;
}

export type resultTypes = accountTypes & {token: string}

class SignInStore {
  
  @observable userAccount: accountTypes = {
        mobile: '',
        password: '',
    };
  
  @observable signinResult: resultTypes;
  
  @observable rememberState: boolean;
  
  @action.bound async signin () {
      const [error, result] = await login(this.userAccount);
      if (error) {
        log({pageId: 'P01', eventId: 'E0105',ext: ''})
        window.localStorage.removeItem('userInfo');
          return
      }
    log({pageId: 'P01', eventId: 'E0106',ext: ''})
    const userInfo = {
          mobile: this.userAccount.mobile,
          passwordLength: this.userAccount.password.length,
          token: result
      }
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
      stores.routingStore.history.push('/Site');
  }
  
  @action.bound async signinTocken (params: {mobile: string}) {
      const [error] = await getUserInfo(params);
      if (error) {
        log({pageId: 'P01', eventId: 'E0105',ext: ''})
        window.localStorage.removeItem('userInfo');
          return
      }
    log({pageId: 'P01', eventId: 'E0106',ext: ''})
    stores.routingStore.history.push('/Site');
  }
  
  @action.bound setRememberState (state: boolean) {
      this.rememberState = state
  }
  
  @action.bound setUserAccount(userAccount: { [key: string]: string }) {
      this.userAccount = Object.assign({}, this.userAccount, userAccount);
  }
  
  
}

export default SignInStore;
